const VariablesPanel = require("../components/variablespanel.js");
const CodePanel = require("../components/codepanel.js");
const GlitchDropAreas = require("../components/glitchdropareas.js");
const SpriteDropAreas = require("./spritedropareas.js");
const LevelsPanel = require("./levels-panel.js");
const SceneDropAreas = require("./scenedropareas.js");
const PanelElement = require("../elements/panel.js");
const ExportMenu = require("./export-menu.js");
const SharingJourneyPanel = require("./sharing-journey-panel.js");
const html = require("choo/html");
module.exports = function GameContext(state, emit) {
  let secondaryPanel;
  let primaryPanel;
  let projectActionsPanel;
  if (state.showLevelsPanel) {
    primaryPanel = LevelsPanel(state, emit);
    secondaryPanel = ExportMenu(state, emit);
  } else {
    primaryPanel = VariablesPanel(state, emit);
  }

  // Sharing mode overrides all other secondary panel uses
  if (
    state.sharingMode &&
    state.sharingMode.active &&
    state.sharingMode.phase === "review"
  ) {
    secondaryPanel = SharingJourneyPanel(state, emit);
  } else if (state.selectedGlitchApplicationId || state.applyingGlitch) {
    secondaryPanel = GlitchDropAreas(state, emit);
  } else if (state.selectedTargetId) {
    secondaryPanel = SpriteDropAreas(state, emit);
  } else if (state.draggingSceneId) {
    secondaryPanel = SceneDropAreas(state, emit);
  } else {
    // secondaryPanel = CodePanel(state, emit)
  }
  if (state.isFullscreen) {
    primaryPanel = VariablesPanel(state, emit);
    secondaryPanel = html` <div style="height:10%"></div>`;
  }
  if (state.isInventoryOpen) {
    primaryPanel = PanelElement({
      color: "purple",
    });
  }
  return [primaryPanel, secondaryPanel];
};
